import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CloudSunRainIcon, GiftIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productImage, totalBonuses, totalVolumes } from '../data/offer';
const highlights = [{
  icon: BookOpenIcon,
  label: `${totalVolumes} tomos premium`
}, {
  icon: GiftIcon,
  label: `${totalBonuses} bonos estratégicos`
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}];
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="bg-stage-deep tech-grid relative isolate overflow-hidden" data-id="element-103" data-mp="sai3x2hdot69">
      <div className="energy-bar h-2 w-full" aria-hidden="true" data-id="element-104" data-mp="ncq0bb7dfim8" />

      <div className="mx-auto max-w-5xl px-4 pb-14 pt-12 text-center lg:pb-20 lg:pt-16" data-id="element-105" data-mp="neknkw647mth">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-md border border-sky/50 bg-sky/15 px-4 py-2 text-xs font-extrabold uppercase tracking-[.14em] text-mutedDark" data-id="element-106" data-mp="3czfkty10i55i">
          <CloudSunRainIcon className="h-4 w-4" aria-hidden="true" data-id="element-107" data-mp="39b4hj226fw3g" /> Megapack Meteorología Listo
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-4xl text-balance text-4xl font-extrabold leading-[1.05] text-white sm:text-5xl lg:text-6xl" data-id="element-108" data-mp="3e8ecsyc8z1z7">
          Todo tu año de Meteorología
          <br data-id="element-109" data-mp="2violwmblv0ck" />
          <span className="text-gold" data-id="element-110" data-mp="2viermmjj2712">resuelto en una tarde.</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-9 max-w-3xl" data-id="element-111" data-mp="2hjf8fuesakca">
          <img src={productImage} alt="Megapack Meteorología Listo: nueve tomos y cinco bonos sobre atmósfera, nubes, presión, vientos, frentes, tormentas, observación y pronóstico" className="mx-auto w-full rounded-xl drop-shadow-[0_24px_44px_rgba(0,0,0,.45)]" data-id="element-112" data-mp="s3mb9x0ezovq" />
        </motion.div>

        <div className="mt-9" data-id="element-113" data-mp="dbasf9bpvozi">
          <Button onClick={scrollToPricing} arrow className="w-full sm:w-auto" data-id="element-114" data-mp="1b15ntam2zpmw">
            Quiero mi Megapack ahora
          </Button>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-2 text-xs font-bold text-onDark" data-id="element-115" data-mp="15zq2dhfzrh3z">
          {highlights.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-md border border-lineDark bg-skyDeep/70 px-3 py-2" data-id="element-116" data-mp="x1wbim0zxfo7">
              <Icon className="h-3.5 w-3.5 text-gold" aria-hidden="true" data-id="element-117" data-mp="3hrlmgnykwhbm" />
              {label}
            </li>)}
        </ul>
      </div>
    </section>;
}